import React, { useRef, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { v4 as uuidv4 } from "uuid";
import "../components/Pantalla.scss";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "&.MuiFormControl-root": {
    width: "100%",
    minWidth: "fit-content"
  },
  "& .MuiOutlinedInput-root": {
    "& .MuiInputBase-inputMultiline": {
      fontSize: "0.8rem",
      fontWeight: 400,
      padding: "4px",
      textAlign: "left",
      borderRadius: "5px",
      border: "1px solid #b9b9b9",
      position: "relative",
      bottom: "6px",
    },
    "& .MuiInputBase-inputMultiline:hover": {
      border: "1px solid #2a2a2a"
    },
    "& .MuiInputBase-inputMultiline:focus": {
      border: "1px solid #0096b3"
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    padding: "4px",
    width: "100%",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(0, 0, 0, 0.87)",
  },
}));

const TextFieldEditable = ({ value, setValue, onEnter, maxCaracteres }) => {
  const [id, setId] = useState("a" + uuidv4().replace(/-/g, ""));

  const keyUp = useRef(0); // Evita que el evento onBlur se dispare luego de onKeyUp
  const altEnter = useRef(0); // Detecta keyDown = alt + enter
  const setingStart = useRef();
  const firstRender = useRef(0);

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      if (altEnter.current !== 0) return;

      keyUp.current = 1;
      e.target.blur();

      return onEnter(e).then(() => {
        keyUp.current = 0;
      });
    }
    return (altEnter.current = 0);
  };

  const handleOnBlur = (e) => {
    if (keyUp.current !== 0) return;
    return onEnter(e);
  };

  const handleInput = (e) => {
    const valor = e.target.value;
    setValue(valor);
  };

  const handleAlt = (e) => {
    setingStart.current = e.target.selectionStart;

    if (e.key === "Enter") {
      e.preventDefault();
    }
    if (e.key === "Enter" && e.altKey) {
      altEnter.current = 1;

      setValue(
        value.slice(0, setingStart.current) +
          "\n" +
          value.slice(setingStart.current, value.length)
      );
      return;
    }
    return;
  };

  useEffect(() => {
    const ctrl = document.getElementById(id);
     if (firstRender.current === 0) {
        firstRender.current = 1;
        return;
      }

    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(setingStart.current + 1, setingStart.current + 1);
    }
  }, [value]);

  return (
    <CustomTextField
      id={id}
      value={value}
      onChange={handleInput}
      onKeyUp={handleEnter}
      onBlur={handleOnBlur}
      onKeyDown={handleAlt}
      inputProps={{ maxLength: maxCaracteres ?? 60 }}
      multiline
    />
  );
};

export default TextFieldEditable;
